import { getUserRole } from '../userLocalDetails';

/**
 * Filters classes based on archive status — teachers only.
 *
 * Rule: If the teacher has ANY active (non-archived) classes, return only
 * active classes. If ALL classes are archived, return all of them so the
 * teacher still sees their data.
 *
 * Non-teacher roles (students) always get the full unfiltered list.
 */
export const filterActiveClasses = (classes) => {
  if (!Array.isArray(classes) || classes.length === 0) return classes || [];
  if (getUserRole() !== 'TEACHER') return classes;
  const hasActive = classes.some((cls) => !cls.isArchived);
  return hasActive ? classes.filter((cls) => !cls.isArchived) : classes;
};
